import {
  ElementRef,
  HostListener,
  Directive,
  AfterContentChecked,
} from '@angular/core';

@Directive({
  selector: 'textarea[adjustable]',
})
export class AdjustableTextareaDirective implements AfterContentChecked {
  @HostListener('input', ['$event.target'])
  onInput(textArea: HTMLTextAreaElement) {
    this.adjust();
  }
  constructor(public element: ElementRef) {}

  ngAfterContentChecked() {
    this.adjust();
  }

  private adjust() {
    this.element.nativeElement.style.overflow = 'hidden';
    this.element.nativeElement.style.height = 'auto';
    this.element.nativeElement.style.height =
      this.element.nativeElement.scrollHeight + 'px';
  }
}
